var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.82 33.44H41.64V19.04C41.64 15.68 39.82 15 37.6 17.52L36 19.34L22.46 34.74C20.6 36.84 21.38 38.56 24.18 38.56H30.36V52.96C30.36 56.32 32.18 57 34.4 54.48L36 52.66L49.54 37.26C51.4 35.16 50.62 33.44 47.82 33.44Z",
    fill: "#ED6E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashSectionIcon);
export default __webpack_public_path__ + "static/media/flash-section-icon.f3d611d117e206d60c7d0b4a8854cdc2.svg";
export { ForwardRef as ReactComponent };